import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardFooter,
  Form,
  FormGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardHeader,
  NavItem,
  Nav,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import "moment-timezone";
import ReactTable from "components/ReactTable/ReactTable.js";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useMemo, useState, useEffect, useContext } from "react";
import {
  NavLink as DomNavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from "react-toastify";
import Moment from "moment";
import ImageGallery from "react-image-gallery";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const SubscriberDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const [horizontalTabs, setHorizontalTabs] = useState("alarms");

  const [params, setParams] = useState(location.state?.value ?? "");
  const [details, setDetails] = useState();
  const [settings, setSettings] = useState();
  const [imageSrc, setImageSrc] = useState([]);
  const privileges = useContext(MainContext);
  const [alert, setAlert] = useState(null);
  const [powerCycleEndpointId, setPowerCycleEndpointId] = useState(null);
  const [rebootEndpointId, setRebootEndpointId] = useState(null);

  useEffect(() => {
    if (
      !Utilities.hasAccess(privileges["devices.subscribers.details.display"])
    ) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData("manual");
  }, []);

  const openDevicePortal = () => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: details.deviceSerialNumber,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const powercycle = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/powercycle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: powerCycleEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the power cycle: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Power Cycle done successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const reboot = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/reboot", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: rebootEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the reboot: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Reboot done successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const showEndpointActionDowndown =
    (Utilities.hasAccess(privileges["devices.endpoints.powercycle"]) &&
      Utilities.validateLicense(
        sessionStorage.getItem("licenseTypes"),
        Utilities.LICENSE_PRO,
      ) &&
      details?.modelType?.includes("PLUS")) ||
    (Utilities.hasAccess(privileges["devices.endpoints.reboot"]) &&
      Utilities.validateLicense(
        sessionStorage.getItem("licenseTypes"),
        Utilities.LICENSE_PRO,
      ));

  const fetchData = (mode) => {
    fetch("/api/v1/subscriber/details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        id: params,
        mode: mode,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.data) {
          setDetails(actualData.data);
        }
        if (actualData.settings) {
          setSettings(actualData.settings);
        }

        const loadImage = async (pos) => {
          try {
            const imageModule = await import(
              `../../../assets/img/devices/${actualData.data.modelType}/${pos}.png`
            );
            return imageModule.default;
          } catch (Exception) {
            return null;
          }
        };

        const loadImages = async () => {
          const promises = [];
          for (var x = 1; x <= 9; x++) {
            promises.push(loadImage(x));
          }

          const images = await Promise.all(promises);
          const finalImages = [];
          images.map((image) => {
            if (image != null) {
              finalImages.push({ original: image, thumbnail: image });
            }
          });
          setImageSrc(finalImages);
        };

        loadImages();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToDeviceDetails = () => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: details.deviceSerialNumber,
      },
    };
    history.push(location);
  };

  const alertPowerCycle = (id) => {
    setPowerCycleEndpointId(id);
    setAlert("cyclePower");
  };

  const alertReboot = (id) => {
    setRebootEndpointId(id);
    setAlert("reboot");
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const alarmsColumns = useMemo(
    () => [
      {
        Header: "Severity",
        accessor: "severity",
        sortBy: "severity",
        Cell: (props) => {
          let value = props.value.toUpperCase();

          // Set the right background color base on the delay
          var color = "";
          if (value == "CR") {
            color = "rgba(232, 80, 77, 1)"; // Muted Red
          } else if (value == "MJ") {
            color = "rgba(237, 145, 49, 1)"; // Soft Orange
          } else if (value == "MN") {
            color = "rgba(240, 205, 102, 1)"; // Soft Yellow
          } else if (value == "NA") {
            color = "rgba(149, 179, 215, 1)"; // Light Steel Blue
          }
          return (
            <div style={{ backgroundColor: color, width: "100%" }}>{value}</div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Condition",
        accessor: "condition",
        sortBy: "condType",
        flex: "1 1 0",
      },
      {
        Header: "Service Affecting",
        accessor: "serviceAffecting",
        sortBy: "servAff",
        Cell: (props) => {
          return <span> {props.value}</span>;
        },
        flex: "1 1 0",
      },
      {
        Header: "Description",
        accessor: "description",
        sortBy: "ifDescr",
        flex: "1 1 0",
      },
      {
        Header: "Occured",
        accessor: "occured",
        sortBy: "occurTime",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Received",
        accessor: "received",
        sortBy: "creationDate",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
    ],
    [],
  );

  const [showLoading, setShowLoading] = useState(false);

  const getUplinkPort = () => {
    if (!details) {
      return "NONE";
    }

    if (details.doubleTagging && details.uplinkPort == "NONE") {
      return "Default (10G-1)";
    } else {
      return details.uplinkPort;
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert == "cyclePower" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to cycle PoE Power for this endpoint ?"
            onConfirm={() => {
              powercycle();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}

        {alert == "reboot" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to reboot this endpoint ?"
            onConfirm={() => {
              reboot();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/Subscribers/list",
                      }}
                    >
                      Subscribers
                    </DomNavLink>
                    {details ? <i>&lt;{details.subscriberName}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>Details</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {imageSrc.length > 0 ? (
            <Col md="4">
              <Card>
                <CardBody style={{ minHeight: "50px", maxHeight: "450px" }}>
                  <ImageGallery items={imageSrc} showPlayButton={false} />
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
          <Col>
            <Card>
              <CardHeader>
                <h6>Subscriber Details</h6>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label>Name</label>
                        <p>{details ? details.subscriberName : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Description</label>
                        <p>{details ? details.subscriberDescription : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Uplink Port</label>
                        <p>{getUplinkPort()}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label>VLAN Id Port #1</label>
                        <p>
                          {details ? details.vlanIdPort1 : ""}
                          {details ? (details.isTaggedVlan1 ? "" : " (U)") : ""}
                        </p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>VLAN Id Port #2</label>
                        <p>
                          {details ? details.vlanIdPort2 : ""}
                          {details ? (details.isTaggedVlan2 ? "" : " (U)") : ""}
                        </p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>POE</label>
                        <p>{details ? details.poe : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label>Allowed:Remapped Tagged VLAN</label>
                        <p>
                          {details
                            ? details.trunkMode
                              ? "all (trunk)"
                              : details.allowedVlan
                            : ""}
                        </p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Allowed:Remapped Tagged VLAN Port #2</label>
                        <p>
                          {details
                            ? details.trunkMode
                              ? "all (trunk)"
                              : details.allowedVlan2
                            : ""}
                        </p>
                      </FormGroup>
                    </Col>
                    <Col>&nbsp;</Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h6>GAM Details</h6>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>System Name</label>
                        <p>{details ? details.deviceName : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label>IP Address</label>
                        <p>{details ? details.deviceIp : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Serial Number</label>
                        <p>{details ? details.deviceSerialNumber : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label>Software</label>
                        <p>{details ? details.deviceFirmware : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <CardFooter>
                <UncontrolledDropdown direction="down">
                  <DropdownToggle
                    caret
                    color="info"
                    style={{
                      lineHeight: "0.7em",
                      marginTop: "10px",
                    }}
                  >
                    Actions
                  </DropdownToggle>
                  <DropdownMenu container={"body"}>
                    <DropdownItem onClick={() => redirectToDeviceDetails()}>
                      View GAM Details
                    </DropdownItem>
                    {sessionStorage
                      .getItem("permissions")
                      .includes("GAM_PORTAL_ACCESS") ? (
                      <>
                        <DropdownItem divider />
                        <DropdownItem onClick={() => openDevicePortal()}>
                          Open GAM Portal
                        </DropdownItem>
                      </>
                    ) : (
                      ""
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardFooter>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardHeader>
                <h6>Endpoint Details</h6>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <label>MAC Address</label>
                        <p>{details ? details.macAddress : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>Name</label>
                        <p>{details ? details.confEndpointName : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>State</label>
                        <p>{details ? details.state : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <label>Model Type</label>
                        <p>{details ? details.type : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>Detected Port</label>
                        <p>{details ? details.detectedPortIfIndex : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>Configured Port</label>
                        <p>{details ? details.confPortIfIndex : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <label>Down/Up PHY rate (Mbps)</label>
                        <p>
                          <span
                            style={{
                              backgroundColor: details ? details.phyColor : "",
                            }}
                          >
                            {details ? details.phyRate : ""}
                          </span>
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>Down/Up Max Bandwidth (Mbps)</label>
                        <p>
                          <span
                            style={{
                              backgroundColor: details ? details.maxColor : "",
                            }}
                          >
                            {details ? details.maxRate : ""}
                          </span>
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label>Bandwidth Name</label>
                        <p>{details ? details.bandwidthName : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label>ASY</label>
                        <p>{details ? details.asy : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Revision</label>
                        <p>{details ? details.revision : ""}</p>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <label>Serial Number</label>
                        <p>{details ? details.serialNumber : ""}</p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {showEndpointActionDowndown ? (
                        <UncontrolledDropdown direction="down">
                          <DropdownToggle
                            caret
                            color="info"
                            style={{
                              padding: "6px 14px 6px 14px",
                              margin: "0px",
                            }}
                          >
                            Actions
                          </DropdownToggle>
                          <DropdownMenu container={"body"}>
                            {Utilities.hasAccess(
                              privileges["devices.endpoints.powercycle"],
                            ) &&
                            Utilities.validateLicense(
                              sessionStorage.getItem("licenseTypes"),
                              Utilities.LICENSE_PRO,
                            ) &&
                            details &&
                            details.modelType &&
                            details.modelType.includes("PLUS") ? (
                              <DropdownItem
                                onClick={() => alertPowerCycle(details.id)}
                              >
                                Cycle PoE Power
                              </DropdownItem>
                            ) : (
                              ""
                            )}

                            {Utilities.hasAccess(
                              privileges["devices.endpoints.reboot"],
                            ) &&
                            Utilities.validateLicense(
                              sessionStorage.getItem("licenseTypes"),
                              Utilities.LICENSE_PRO,
                            ) ? (
                              <DropdownItem
                                onClick={() => alertReboot(details.id)}
                              >
                                Reboot
                              </DropdownItem>
                            ) : (
                              ""
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "alarms"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "alarms" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("alarms")}
                        >
                          Alarms
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>
                <TabContent
                  id="my-tab-content"
                  activeTab={horizontalTabs}
                  style={{ paddingLeft: "20px" }}
                >
                  {details ? (
                    <TabPane tabId="alarms" role="tabpanel">
                      <ReactTable
                        query="/api/v1/endpoint/details/alarms"
                        columns={alarmsColumns}
                        title="Alarms"
                        param={details.macAddress}
                        subtable="true"
                        className="-striped -highlight primary-pagination"
                      />{" "}
                    </TabPane>
                  ) : (
                    ""
                  )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SubscriberDetails;
